<app-filters-dialog-frame>
  @if (form) {
    <form [formGroup]="form" preventFormSubmit>
      <div [class]="formGridStyle">
        <app-input
          labelKey="title"
          formControlName="title"
          [formGroup]="form"
        ></app-input>
        <app-select
          labelKey="representative"
          [formGroup]="form"
          [isAutocomplete]="true"
          formControlName="person_id"
          [options]="representativesOptions"
          [loading]="!representativesOptions.length"
        ></app-select>
        <app-input
          labelKey="minOrderCount"
          [formGroup]="form"
          onlyNumbers
          [isFloatNumber]="true"
          commasSeparateNumbers
          formControlName="min_order_count"
        ></app-input>
        <app-input
          labelKey="code"
          formControlName="code"
          [formGroup]="form"
        ></app-input>
        <app-input
          labelKey="customerPhone"
          formControlName="phone"
          [formGroup]="form"
        ></app-input>
        <app-input
          labelKey="representativeMobile"
          formControlName="mobile"
          [formGroup]="form"
        ></app-input>
        @if (userRoles && userRoles?.includes(Roles.ViewSellerFilter)) {
          <app-select
            labelKey="seller"
            [formGroup]="form"
            formControlName="seller_id"
            [options]="sellersOptions"
            [loading]="sellersOptions.length === 0"
          ></app-select>
        }
        <app-date-picker
          labelKey="createdDateMin"
          formControlName="created_at_min"
          [formGroup]="form"
        ></app-date-picker>
        <app-date-picker
          labelKey="createdDateMax"
          formControlName="created_at_max"
          [formGroup]="form"
        ></app-date-picker>
        <app-select
          labelKey="customers.form.category"
          [formGroup]="form"
          formControlName="category"
          [options]="categoryOptions"
          selectOptionsTranslatePrefix="enums.customerCategoryEnum"
        ></app-select>
        <app-select
          labelKey="customers.form.saleLine"
          [formGroup]="form"
          formControlName="capillary_sales_line_id"
          [options]="saleLineOptions"
        ></app-select>
        <app-select
          labelKey="customers.form.customerType"
          [formGroup]="form"
          formControlName="type"
          [options]="typeOptions"
          selectOptionsTranslatePrefix="enums.customerTypeEnum"
        ></app-select>
        <app-select
          labelKey="customers.form.credibilityBySeller"
          [formGroup]="form"
          formControlName="credibility_by_seller"
          [options]="credibilityOptions"
          selectOptionsTranslatePrefix="enums.CustomerCredibilityEnum"
        ></app-select>
        @if (userRoles && !userRoles?.includes(Roles.Seller)) {
          <app-select
            labelKey="customers.form.credibilityBySalesManager"
            [formGroup]="form"
            formControlName="credibility_by_sales_manager"
            [options]="credibilityOptions"
            selectOptionsTranslatePrefix="enums.CustomerCredibilityEnum"
          ></app-select>
        }
        <app-select
          labelKey="callFrom"
          [formGroup]="form"
          formControlName="did_we_contact"
          [options]="didWeContactOptions"
        ></app-select>
        <app-select
          labelKey="propertyOwnershipStatus"
          [formGroup]="form"
          formControlName="is_property_owner"
          [options]="propertyOwnershipStatusOptions"
        ></app-select>
        <app-select
          labelKey="lockStatus"
          [formGroup]="form"
          formControlName="locked"
          [options]="lockedStatusOptions"
        ></app-select>

        <app-input
          labelKey="customers.form.hpTitle"
          formControlName="hp_title"
          [formGroup]="form"
        ></app-input>
        <app-input
          labelKey="customers.form.hpCode"
          formControlName="hp_code"
          [formGroup]="form"
          onlyNumbers
          [isFloatNumber]="false"
        ></app-input>
      </div>
      <div class="flex w-full justify-end gap-2 mt-4">
        <button mat-stroked-button color="primary" (click)="reset()">
          {{ "removeFilters" | translate }}</button
        ><button
          mat-flat-button
          color="primary"
          class="!text-white"
          (click)="submit()"
        >
          {{ "submit" | translate }}
        </button>
      </div>
    </form>
  }
</app-filters-dialog-frame>
